import { useState, useEffect } from 'react';
import axios from 'axios';

const useTeamCompetitionData = (competitionId) => {
  const [teams, setTeams] = useState([]);
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTeamCompetitionData = async () => {
      try {
        console.log('Fetching team competition data for competitionId:', competitionId);
        setLoading(true);
		console.log('Wysyłam żądanie do /api/league/[compId]');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/league/${competitionId}`);
        const { teams: teamData, matches: matchData } = response.data;

        console.log('Teams:', teamData);
        console.log('Matches:', matchData);

        setTeams(teamData);
        setMatches(matchData);
      } catch (err) {
        setError('Błąd podczas pobierania danych tabeli ligi: ' + err.message);
        console.error('Error fetching team competition data:', err);
      } finally {
        setLoading(false);
        console.log('Finished fetching team competition data, loading:', false);
      }
    };

    if (competitionId) {
      fetchTeamCompetitionData();
    } else {
      console.log('No competitionId provided, skipping fetch');
      setLoading(false);
    }
  }, [competitionId]);

  return { teams, matches, loading, error };
};

export default useTeamCompetitionData;